import type { Amenity } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import {
	AMENITIES,
	BATH_ITEMS,
	FACILITIES,
} from "@/components/features/items/edit/_shared/constants/amenities-and-facilities";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { CheckboxGroupWithAccordionField } from "@/components/ui/form/fields/check-box-field/check-box-group-with-accordion";

import { useAmenitiesOfHotelPolicy } from "./hooks";

import type { CheckedState } from "@radix-ui/react-checkbox";

export const QuestionAmenities = () => {
	const { amenities, updateAmenities } = useAmenitiesOfHotelPolicy();

	const roomAmenities = AMENITIES.map((item) => {
		return {
			id: "room_amenitiesField_" + item.key,
			label: item.key,
			value: item.value,
		} satisfies FormOptionType;
	});

	const updateAmenity = (checked: CheckedState, item: FormOptionType) => {
		if (checked === "indeterminate") return;

		updateAmenities(checked, item.value as Amenity);
	};

	const roomFacilities = FACILITIES.map((item) => {
		return {
			id: "room_amenities_facilities_" + item.key,
			label: item.key,
			value: item.value,
		} satisfies FormOptionType;
	});

	const bethRoomAmenities = BATH_ITEMS.map((item) => {
		return {
			id: "room_amenities_bath_items_" + item.key,
			label: item.key,
			value: item.value,
		} satisfies FormOptionType;
	});

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"部屋のアメニティ・設備"}
			guide="ホテルポリシーで設定した以外のアメニティや設備が存在する場合は、こちらで追加設定が可能です。"
			isEdited={amenities.isEdited}
			hasError={amenities.hasError}
			inputChildren={
				<>
					<CheckboxGroupWithAccordionField
						accordionLabel="部屋のアメニティ"
						checkBoxGroupProps={{
							value: amenities.value.map((item) => item.value),
							options: roomAmenities,
							handleCheckedChange: updateAmenity,
							gridCols: 2,
						}}
					/>
					<CheckboxGroupWithAccordionField
						accordionLabel="部屋の設備"
						checkBoxGroupProps={{
							value: amenities.value.map((item) => item.value),
							options: roomFacilities,
							handleCheckedChange: updateAmenity,
							gridCols: 2,
						}}
					/>
					<CheckboxGroupWithAccordionField
						accordionLabel="バスルーム"
						checkBoxGroupProps={{
							value: amenities.value.map((item) => item.value),
							options: bethRoomAmenities,
							handleCheckedChange: updateAmenity,
							gridCols: 2,
						}}
					/>
				</>
			}
		/>
	);
};

QuestionAmenities.displayName = "QuestionAmenities";
